  <div>
    <div [hidden]="!viewToggled" class="field-row fx-layout-row fx-wrap fx-justify-start fx-align-baseline">
      @if (!isCreatingEntity) {
        <div class="field-label fx-flex-100-33-percent">
          {{ fieldConfig.label }}
          @if (fieldConfig.tooltip) {
            <span #tooltip="matTooltip" (click)="onClickTooltip(tooltip)"
                  [matTooltip]="fieldConfig.tooltip">
              <i class="mdi mdi-help-circle tooltip-icon"></i>
            </span>
          }
        </div>
      }
      @if (preconditionsForEdition) {
        <div class="field-container fx-flex-100-66-percent fx-layout-col">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'LABEL.ASSET_TYPE_NAME' | translate }}</mat-label>
            <mat-select-asset-type-autocomplete #inputField [disabled]="(asyncPreconditionsForEdition$ | async) === false"
                                                [required]="fieldConfig.customOptions?.required"
                                                [entityType]="entity?.objectType"
                                                [formControl]="form.controls.field">
            </mat-select-asset-type-autocomplete>
            @if (isCreatingEntity && fieldConfig.tooltip) {
              <span matTextSuffix matTooltipPosition="below"
                    [matTooltip]="fieldConfig.tooltip" #tooltip="matTooltip" (click)="onClickTooltip(tooltip)">
                <i class="mdi mdi-help-circle tooltip-icon"></i>
              </span>
            }
          </mat-form-field>
          @if (isSingleField) {
            <div class="save-options">
              <button (click)="onClickCancel()" (keyup.escape)="onEscapeCancel($event)" class="button">
                <i class="mdi mdi-close"></i>
              </button>
              <button (click)="onClickSave()" (keyup.escape)="onEscapeCancel($event)" [disabled]="!form.valid"
                      class="button save">
                <i class="mdi mdi-check"></i>
              </button>
            </div>
          }
        </div>
      } @else {
        <div class="field-container clickable-field fx-flex-100-66-percent fx-layout-col">
          <div
            [ngClass]="{'read-value': accessManager.hasAllNeededPermissions(permissionsForEdition) && preconditionsForEdition}"
            tabindex="0">
            @if (accessManager.hasAllNeededPermissions(permissionsForEdition)) {
              <span class="overlay-icon">
                <i class="mdi mdi-pencil-off tooltip-icon"></i>
              </span>
            }
          </div>
        </div>
      }
    </div>
  </div>

